export enum presentationType {
  bowtieListing = 5,
  riskMatrixListing = 6
}
